import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import { Link } from "react-router-dom";
import MapAssetAndDevicesJS from "components/maps/MapAssetAndDevicesJS";

const PrevAssetContainer = ({ asset, showPreview }) => {
    const [t] = useTranslation("tables");
    const [_Tc] = useTranslation("choices");
    const { panel } = useContext(AuthContext);
    return (
        <div
            className={`col preview-row ${showPreview ? "" : "d-none"}`}
            style={{ width: "300px", maxWidth: "300px" }}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{ width: "300px" }}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon={panel.panel_type === "b" ? "bridge-water" : "dumpster"} />
                            </div>
                            <div className="preview-title">
                                <label>UID</label>
                                <div>{asset.uid}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{t("containers.model")}</label>
                            <div className="preview-input">
                                {asset.waste_model}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{t("containers.description")}</label>
                            <div className="preview-input">{asset.description}</div>
                        </div>
                        <div className="preview-item">
                            <label>{t("containers.device")}</label>
                            <div className="preview-input">
                                {asset.uuids}
                                <Link to={"/asset-management/devices/?uuid=" + asset.uuids} className="mb-2 ms-2"><FontAwesomeIcon icon="eye" /></Link>
                            </div>
                        </div>

                        <div className="preview-item">
                            <label>{t("containers.location")}</label>
                            <MapAssetAndDevicesJS
                                asset={asset}
                                devices={[]}
                                mapId={`map-preview-${asset.id || asset.uid}`}
                                height="120px"
                                show={showPreview}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevAssetContainer;
